import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { translateText } from "../Navbar/Navbar";
import axios from "axios";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";

const APII = "https://lcoiapi.emedha.in/appi";

const AllIndiaSchooling = ({ selectedLang }) => {
    const navigate = useNavigate();

    // Translation state
    const [translated, setTranslated] = useState({
        GalleryTitle: "All India Schooling 2027",
        AwardsBtn: "LCOI Awards 2026",
        MissionBtn: "Mission 1.5 Summit",
        SchoolingBtn: "All India Schooling 2026",
        NoImages: "No images found for this category.",
    });

    // Images fetched from API
    const [imagesData, setImagesData] = useState([]);
    
    // Active Tab Configuration
    const [activeTab, setActiveTab] = useState("awards");

    // Modal / Lightbox State for Zoom feature
    const [lightbox, setLightbox] = useState({
        isOpen: false,
        currentImgIndex: 0,
        filteredList: []
    });

    // Fetch images on mount
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await axios.get(`${APII}/images`);
                setImagesData(res.data);
            } catch (err) {
                console.error("Error fetching images:", err);
            }
        };
        fetchImages();
    }, []);

    // Translation Logic
    useEffect(() => {
        async function translateAll() {
            const englishTexts = {
                GalleryTitle: "All India Schooling 2026",
                AwardsBtn: "LCOI Awards 2026",
                MissionBtn: "Mission 1.5 Summit",
                SchoolingBtn: "All India Schooling 2026",
                NoImages: "No images found for this category.",
            };

            let translatedObj = {};
            for (let key in englishTexts) {
                try {
                    translatedObj[key] = await translateText(englishTexts[key], selectedLang);
                } catch {
                    translatedObj[key] = englishTexts[key];
                }
            }
            setTranslated(translatedObj);
        }
        translateAll();
    }, [selectedLang]);

    // Filtering logic based on user specification
    const getFilteredImages = () => {
        if (activeTab === "awards") {
            return imagesData.filter(
                (img) =>
                    img.title === "01-06-2026_Cam1(100)" ||
                    img.title === "01-06-2026_Cam1(101)" ||
                    img.title === "01-06-2026_Cam2"
            );
        } else if (activeTab === "mission") {
            return imagesData.filter((img) => img.title === "02-06-2026");
        } else if (activeTab === "schooling") {
            return imagesData.filter(
                (img) =>
                    img.title === "03-06-2026" ||
                    img.title === "04-06-2026" ||
                    img.title === "05-06-2026"
            );
        }
        return [];
    };

    const currentGalleryImages = getFilteredImages();

    // Lightbox handlers
    const openLightbox = (index) => {
        setLightbox({
            isOpen: true,
            currentImgIndex: index,
            filteredList: currentGalleryImages
        });
    };

    const closeLightbox = () => {
        setLightbox({ ...lightbox, isOpen: false });
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setLightbox((prev) => ({
            ...prev,
            currentImgIndex: prev.currentImgIndex === 0 ? prev.filteredList.length - 1 : prev.currentImgIndex - 1
        }));
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setLightbox((prev) => ({
            ...prev,
            currentImgIndex: prev.currentImgIndex === prev.filteredList.length - 1 ? 0 : prev.currentImgIndex + 1
        }));
    };

    // Responsive Inline Styling Layouts
    const styles = {
        container: {
            padding: "2rem 1rem",
            fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            maxWidth: "1200px",
            margin: "0 auto",
        },
        header: {
            textAlign: "center",
            fontSize: "2rem",
            fontWeight: "700",
            color: "#1a202c",
            marginBottom: "2rem",
        },
        tabContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            flexWrap: "wrap",
            marginBottom: "2.5rem",
        },
        button: (isActive) => ({
            padding: "12px 24px",
            fontSize: "14px",
            fontWeight: "600",
            borderRadius: "30px",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: isActive ? "0 4px 12px rgba(0, 123, 255, 0.3)" : "0 2px 4px rgba(0,0,0,0.05)",
            backgroundColor: isActive ? "#007bff" : "#efefef",
            color: isActive ? "#ffffff" : "#4a5568",
        }),
        galleryGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: "20px",
            marginTop: "20px",
        },
        card: {
            backgroundColor: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
            transition: "transform 0.3s ease, boxShadow 0.3s ease",
            cursor: "pointer",
            border: "1px solid #e2e8f0",
        },
        imageWrapper: {
            width: "100%",
            height: "220px",
            backgroundColor: "#f7fafc",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        img: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.5s ease",
        },
        cardInfo: {
            padding: "12px 16px",
            fontSize: "13px",
            color: "#718096",
            textAlign: "center",
            borderTop: "1px solid #edf2f7",
            backgroundColor: "#fafafa"
        },
        emptyMessage: {
            textAlign: "center",
            color: "#a0aec0",
            fontSize: "16px",
            marginTop: "3rem"
        },
        // Lightbox Backdrop styles
        lightboxOverlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.92)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column"
        },
        lightboxClose: {
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "24px",
            cursor: "pointer",
            padding: "8px",
            display: "flex",
            alignItems: "center"
        },
        lightboxNavBtn: (side) => ({
            position: "absolute",
            [side]: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "rgba(255,255,255,0.1)",
            border: "none",
            color: "white",
            padding: "16px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            transition: "background 0.2s",
        }),
        lightboxImg: {
            maxWidth: "90%",
            maxHeight: "80vh",
            objectFit: "contain",
            boxShadow: "0 5px 25px rgba(0,0,0,0.5)",
            borderRadius: "4px"
        },
        lightboxCaption: {
            color: "#ccc",
            marginTop: "15px",
            fontSize: "15px",
            fontWeight: "500"
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>{translated.GalleryTitle}</h2>

            {/* Event Navigation Buttons */}
            <div style={styles.tabContainer}>
                <button
                    style={styles.button(activeTab === "awards")}
                    onClick={() => setActiveTab("awards")}
                >
                    {translated.AwardsBtn}
                </button>
                <button
                    style={styles.button(activeTab === "mission")}
                    onClick={() => setActiveTab("mission")}
                >
                    {translated.MissionBtn}
                </button>
                <button
                    style={styles.button(activeTab === "schooling")}
                    onClick={() => setActiveTab("schooling")}
                >
                    {translated.SchoolingBtn}
                </button>
            </div>

            {/* Gallery Grid */}
            {currentGalleryImages.length > 0 ? (
                <div style={styles.galleryGrid}>
                    {currentGalleryImages.map((img, index) => (
                        <div 
                            key={img.id || index} 
                            style={styles.card}
                            onClick={() => openLightbox(index)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 15px rgba(0,0,0,0.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.05)";
                            }}
                        >
                            <div style={styles.imageWrapper}>
                                <img
                                    src={img.image_url}
                                    style={styles.img}
                                    alt={img.title}
                                    loading="lazy"
                                />
                            </div>
                            {/* <div style={styles.cardInfo}>
                                {img.title}
                            </div> */}
                        </div>
                    ))}
                </div>
            ) : (
                <p style={styles.emptyMessage}>{translated.NoImages}</p>
            )}

            {/* Zoom Lightbox Modal */}
            {lightbox.isOpen && lightbox.filteredList.length > 0 && (
                <div style={styles.lightboxOverlay} onClick={closeLightbox}>
                    <button style={styles.lightboxClose} onClick={closeLightbox}>
                        <FaTimes />
                    </button>

                    {lightbox.filteredList.length > 1 && (
                        <>
                            <button style={styles.lightboxNavBtn("left")} onClick={prevImage}>
                                <FaArrowLeft />
                            </button>
                            <button style={styles.lightboxNavBtn("right")} onClick={nextImage}>
                                <FaArrowRight />
                            </button>
                        </>
                    )}

                    <img
                        src={lightbox.filteredList[lightbox.currentImgIndex]?.image_url}
                        alt="Zoomed view"
                        style={styles.lightboxImg}
                        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the image
                    />

                    <div style={styles.lightboxCaption}>
                        {lightbox.filteredList[lightbox.currentImgIndex]?.title} ({lightbox.currentImgIndex + 1} / {lightbox.filteredList.length})
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllIndiaSchooling;